const state = {
  show: false,
  message: ''
}

const mutations = {
  setShow (state, show) {
    state.show = show
  },

  setMessage (state, message) {
    state.message = message
  }
}

const actions = {
  show ({ commit }, message) {
    commit('setMessage', message)
    commit('setShow', true)
  },

  hide ({ commit }) {
    commit('setShow', false)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
